import React from "react";
import { Award, MapPin, Zap, Activity } from "lucide-react";
export default function WhyChooseQstGeotechnical() {
  const differentiators = [{
    title: "LICENSING",
    description: "Fully certified professionals delivering compliant, industry-standard geotechnical testing.",
    icon: <Award className="w-12 h-12 text-[#6B28A1]" />
  }, {
    title: "OWNERSHIP",
    description: "Locally owned and operated, deeply rooted in the community we serve.",
    icon: <MapPin className="w-12 h-12 text-[#6B28A1]" />
  }, {
    title: "SPEED",
    description: "Fast turnaround times and rapid mobilization to keep your projects on schedule.",
    icon: <Zap className="w-12 h-12 text-[#6B28A1]" />
  }, {
    title: "QUALITY",
    description: "Precision analysis and detailed reporting using state-of-the-art technology.",
    icon: <Activity className="w-12 h-12 text-[#6B28A1]" />
  }];
  return <section id="why-choose-qst-geotechnical" className="dark bg-background text-foreground py-24 px-4 sm:px-8 bg-white text-[hsl(278,32%,20%)]">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {differentiators.map((item, i) => <div key={i} data-index={i} className="flex flex-col items-start gap-6">
              <div className="mb-2">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold uppercase tracking-wide font-sans text-[hsl(278,32%,20%)]">
                {item.title}
              </h3>
              <p className="text-base leading-relaxed text-[hsl(278,32%,20%)]/80 font-sans">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}